import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appConditionalBackgroundColor]'
})
export class ConditionalBackgroundColorDirective {

  @Input() permissionArray!: Array<Array<any>>;

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit() {
    // if (this.permissionArray.every((perm) => this.permissionService.checkPermissionsForSection(perm[0], perm[1]) === false)) {
    //   this.elementRef.nativeElement.style.display = 'none';
    // }
  }

}
